import React, { useState, useEffect } from "react";
import BaseModal from "./BaseModal";
import ScannerSettingsForm from "../Forms/ScannerSettingsForm";
// import ModelsAPI from "../../API/models.api";
// import { ErrorAlert, SuccessAlert } from "../../utils/Alerts";
// import LogCapture from "../../utils/LogHelper";
import { useTranslation } from "react-i18next";

const ScannerSettingsModal = ({ isVisible, setIsVisible, data }) => {
    const [scannerData, setScannerData] = useState({});
    const [isSubmitting] = useState(false);
    const [isFormSubmitted] = useState(false);
    const [, setIsFormValid] = useState(false);
    const { t } = useTranslation();

    useEffect(() => {
        setScannerData(data.settings || {});
    }, [data]);

    // const handleSubmit = async () => {
    //     setIsFormSubmitted(true);
    //     if (!isFormValid) return;
    //     setIsSubmitting(true);
    //     ModelsAPI.updateModel({
    //         id: data.id,
    //         settings: scannerData,
    //     })
    //         .then(() => {
    //             setIsVisible(false);
    //             SuccessAlert("Access Granted");
    //             LogCapture.info(
    //                 `Scanner settings updated with model id: ${data?.id}`
    //             );
    //         })
    //         .catch((error) => {
    //             ErrorAlert(error);
    //             LogCapture.error(
    //                 `Couldn't updated Scanner settings with model id: ${data?.id}, error: ${error}`
    //             );
    //         })
    //         .finally(() => setIsSubmitting(false));
    // };

    return (
        <BaseModal
            isVisible={isVisible}
            setIsVisible={setIsVisible}
            isSubmitting={isSubmitting}
            title={t("scannerSettings")}
            titleIcon="fas fa-tools"
            // action={{
            //     name: t("edit"),
            //     submitAction: handleSubmit,
            //     disabled: isSubmitting,
            // }}
            isSmall={true}
        >
            <ScannerSettingsForm
                scannerSettings={scannerData}
                setScannerSettings={setScannerData}
                isFormSubmitted={isFormSubmitted}
                setIsFormValid={setIsFormValid}
                disabled={true}
            />
        </BaseModal>
    );
};
export default ScannerSettingsModal;
